export const OverviewConversionsMobileDataSetQueryIds = {
  ACTION: "5722078678351872",
  CLICK: "5663297554612224",
};

export const OverviewConversionsMobileFilterQueryIds = {
  CAMP: "5728744266268672",
  ADGROUP: "5658330156498944",
  KEYWORD: "5718746756808704",
};
